import { ArrayField } from 'react-hook-form'
import {
  Question,
  QuestionInTemplate,
  QuestionnaireTemplateSection,
  QuestionRule,
  QuestionRuleTypes,
} from './resourceExplorer'

export enum QuestionRuleFormFields {
  QuestionId = 'questionId',
  RuleType = 'ruleType',
  ConditionValue = 'conditionValue',
  SectionQuestionTargets = 'sectionQuestionTargets',
}

export type SaveRulesValues = {
  [QuestionRuleFormFields.QuestionId]: number
  [QuestionRuleFormFields.RuleType]: QuestionRuleTypes
  [QuestionRuleFormFields.ConditionValue]: string
  [QuestionRuleFormFields.SectionQuestionTargets]: { targetQuestionId: number }[]
}

export interface RuleDialogProps {
  open: boolean
  closeDialog: () => void
  rulesForCurrentQuestion: QuestionRule[]
  questionsInTemplate: QuestionInTemplate[]
}

export interface RuleViewProps {
  rules?: Partial<ArrayField<SaveRulesValues, 'id'>>[]
  questionToShow: Question
  questionsInTemplate: { id: number; questionId: number; isRequired: boolean }[]
  sectionsInTemplate: QuestionnaireTemplateSection[]
  handleSaveRule: (values: SaveRulesValues) => void
  removeRule?: (index: number) => void
  questionInTemplate: QuestionInTemplate
}

export interface RuleAddProps extends RuleViewProps {
  defaultValues?: Partial<ArrayField<SaveRulesValues, 'id'>>
  currentRuleIndex?: number
}
